/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.RoyaltyExport {
    angular.module("meevo.plugins.royaltyExport", []);
}